import { Stack } from "@fluentui/react";
import React from "react";
import { defaultPostChatSurveyPaneControlProps } from "./common/defaultProps/defaultPostChatSurveyPaneControlProps";
import { defaultPostChatSurveyPaneGeneralStyles } from "./common/defaultProps/defaultStyles/defaultPostChatSurveyPaneGeneralStyles";
import { getValidatedURL } from "../../common/utils";

function PostChatSurveyPane(props) {
  var _props$controlProps, _props$controlProps2, _props$styleProps, _props$controlProps3, _props$controlProps4;

  const elementId = ((_props$controlProps = props.controlProps) === null || _props$controlProps === void 0 ? void 0 : _props$controlProps.id) ?? defaultPostChatSurveyPaneControlProps.id;
  const inputUrl = ((_props$controlProps2 = props.controlProps) === null || _props$controlProps2 === void 0 ? void 0 : _props$controlProps2.surveyURL) ?? defaultPostChatSurveyPaneControlProps.surveyURL;
  const containerStyles = {
    root: Object.assign({}, defaultPostChatSurveyPaneGeneralStyles, (_props$styleProps = props.styleProps) === null || _props$styleProps === void 0 ? void 0 : _props$styleProps.generalStyleProps)
  };
  const iframeStyles = {
    height: "100vh",
    width: "100%",
    display: "block",
    maxHeight: "100%"
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack, {
    id: elementId,
    tabIndex: -1,
    styles: containerStyles,
    role: (_props$controlProps3 = props.controlProps) === null || _props$controlProps3 === void 0 ? void 0 : _props$controlProps3.role
  }, /*#__PURE__*/React.createElement("iframe", {
    id: elementId + "-Iframe" // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ,
    src: getValidatedURL(inputUrl),
    title: ((_props$controlProps4 = props.controlProps) === null || _props$controlProps4 === void 0 ? void 0 : _props$controlProps4.title) ?? defaultPostChatSurveyPaneControlProps.title,
    style: iframeStyles,
    frameBorder: "0"
  })));
}

export default PostChatSurveyPane;